/* BINDT · Kohl Liner pre-order PDP · FlashReach
   - pack + shade selection, pre-order add to cart (GoKwik-aware, pack grouped)
   - gallery, tabs, sticky bar, related-products fallback
   Safe to load more than once. */
(function () {
  if (window.BKKohl) { window.BKKohl.initAll(); return; }

  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var inr = function (p) { return '₹' + (p / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); };
  var qa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var mainApi = null;

  function initMain(root) {
    if (root.__bk) return; root.__bk = true;
    var q = function (s) { return root.querySelector(s); };
    var D = JSON.parse(q('[data-bk-data]').textContent);
    var V = D.variants || [];
    if (!V.length) return;

    /* swatch colours: "Name:#hex" per line */
    var SW = {};
    String(D.swatches || '').split(/\n/).forEach(function (l) {
      var i = l.lastIndexOf(':'); if (i > 0) SW[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim();
    });
    var shades = V.map(function (v) { return v.title; });
    function color(s) { return SW[String(s).toLowerCase()] || '#3E2C23'; }
    function vFor(s) { s = String(s).toLowerCase(); for (var i = 0; i < V.length; i++) if (V[i].title.toLowerCase() === s) return V[i];
      for (i = 0; i < V.length; i++) if (V[i].title.toLowerCase().indexOf(s) > -1 || s.indexOf(V[i].title.toLowerCase()) > -1) return V[i]; return V[0]; }
    var price = V[0].price;
    var a = shades[0], b = shades[1] || shades[0];
    var defaults = { 1: [a], 2: [a, b], 3: [a, a, b] };
    var state = { n: 1, units: [a] };

    qa('[data-pp]', root).forEach(function (el) { el.textContent = inr(price * (+el.dataset.pp)); });
    var per = q('[data-bk-per]'); if (per) per.textContent = inr(price) + ' per liner';

    /* gallery */
    var track = q('.bk-track'), slides = qa('.bk-slide', root), thumbs = qa('.bk-thumb', root), dots = q('.bk-dots');
    slides.forEach(function (_, i) { var s = document.createElement('span'); if (!i) s.className = 'on'; dots.appendChild(s); });
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () { var c = cur();
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === c); });
      qa('span', dots).forEach(function (d, i) { d.className = i === c ? 'on' : ''; }); }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    q('.bk-arrow.prev').addEventListener('click', function () { go(cur() - 1); });
    q('.bk-arrow.next').addEventListener('click', function () { go(cur() + 1); });
    function showShade(s) { var v = vFor(s); if (!v.media) return;
      for (var i = 0; i < slides.length; i++) if (slides[i].dataset.media == String(v.media)) { go(i); return; } }

    /* pencils */
    function pen(c) { return '<svg viewBox="0 0 16 64" aria-hidden="true"><path d="M8 1.5 10.6 10H5.4Z" fill="' + c + '"/><path d="M5.4 10 4 23h8l-1.4-13Z" fill="#E6C3A2"/><rect x="4" y="23" width="8" height="40" rx="2" fill="#D9A982"/><rect x="4" y="28" width="8" height="1.6" fill="#C4916A"/><rect x="4" y="31" width="8" height="1" fill="#C4916A"/></svg>'; }
    function drawPens() { qa('.bk-pens', root).forEach(function (el) { var n = +el.dataset.pens, arr = n === state.n ? state.units : defaults[n];
      el.innerHTML = arr.map(function (s) { return pen(color(s)); }).join(''); }); }

    /* units */
    function renderUnits() {
      var box = q('[data-bk-units]'); box.innerHTML = '';
      state.units.forEach(function (u, idx) {
        var row = document.createElement('div'); row.className = 'bk-unit';
        row.innerHTML = (state.n > 1 ? '<span class="bk-unit-name">Liner ' + (idx + 1) + '</span>' : '') + '<div class="bk-shades" role="radiogroup" aria-label="Shade for liner ' + (idx + 1) + '"></div>';
        var g = row.querySelector('.bk-shades');
        shades.forEach(function (s) { var v = vFor(s), bt = document.createElement('button');
          bt.type = 'button'; bt.className = 'bk-shade'; bt.setAttribute('role', 'radio'); bt.setAttribute('aria-checked', u === s);
          bt.innerHTML = '<i style="background:' + color(s) + '"></i>' + s; if (v.available === false) bt.disabled = true;
          bt.addEventListener('click', function () { state.units[idx] = s; renderUnits(); update(); showShade(s); });
          g.appendChild(bt); });
        box.appendChild(row);
      });
    }
    function setPack(n, keep) { state.n = n; if (!keep) state.units = defaults[n].slice();
      qa('.bk-pack', root).forEach(function (p) { p.setAttribute('aria-checked', +p.dataset.n === n); });
      renderUnits(); update(); }
    function update() {
      drawPens();
      var total = price * state.n, ok = state.units.every(function (s) { return vFor(s).available !== false; });
      q('[data-bk-cta-price]').textContent = inr(total);
      var lab = q('[data-bk-shade-label]'); lab.firstChild.nodeValue = state.n > 1 ? 'Choose your shades ' : 'Choose your shade ';
      q('[data-bk-shade-name]').textContent = state.n > 1 ? state.units.join(' + ') : state.units[0];
      var cta = q('[data-bk-cta]'); cta.disabled = !ok; q('[data-bk-cta-txt]').textContent = ok ? D.cta : 'Sold out';
      var sc = q('[data-bk-st-cta]'); if (sc) sc.textContent = (ok ? D.cta + ' · ' : 'Sold out · ') + inr(total);
      var sn = q('[data-bk-st-name]'); if (sn) sn.textContent = state.n === 1 ? state.units[0] : state.n + ' liners · ' + state.units.join(' + ');
    }
    qa('.bk-pack', root).forEach(function (p) { p.addEventListener('click', function () { setPack(+p.dataset.n); }); });

    /* add to cart */
    function toast(m) { var t = q('[data-bk-toast]'); t.textContent = m; t.classList.add('show'); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2600); }
    function err(m) { var e = q('[data-bk-err]'); e.textContent = m || ''; e.style.display = m ? 'block' : 'none'; }
    function openCart() {
      try { if (typeof window.refreshCartUI === 'function') return window.refreshCartUI({ openDrawer: true }); } catch (e) {}
      try { if (window.gokwikSdk && typeof gokwikSdk.openSidebarCart === 'function') { gokwikSdk.openSidebarCart(); return; } } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (!document.querySelector('cart-drawer')) window.location.href = rootUrl + 'cart';
    }
    function add(btn) {
      err('');
      var key = 'BK-' + Date.now().toString(36), n = state.n, tag = D.tag, counts = {};
      state.units.forEach(function (s) { counts[s] = (counts[s] || 0) + 1; });
      var suffix = tag ? ' (' + tag + ')' : '';
      var label = (n > 1 ? D.title + ' · Pack of ' + n : D.title) + suffix;
      var items = Object.keys(counts).map(function (s) { var p = {};
        if (tag) { p[tag] = 'Ships from ' + D.shipDate; p._preorder = 'true'; }
        p._pack_key = key; p._pack_size = String(n); p._pack_label = label; p._pack_shade = s;
        return { id: vFor(s).id, quantity: counts[s], properties: p }; });
      if (D.preview) { toast('Added: ' + label + ' · ' + inr(price * n)); return; }
      var old = btn.innerHTML; btn.classList.add('loading'); btn.textContent = 'Adding…';
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { if (!tag) return; var at = {}; at[tag] = 'Yes · ships from ' + D.shipDate;
          return fetch(rootUrl + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: at }) }).catch(function () {}); })
        .then(openCart)
        .catch(function (j) { err((j && (j.description || j.message)) || 'Something went wrong. Please try again.'); })
        .then(function () { btn.classList.remove('loading'); btn.innerHTML = old; update(); });
    }
    q('[data-bk-cta]').addEventListener('click', function () { add(this); });
    var stc = q('[data-bk-st-cta]'); if (stc) stc.addEventListener('click', function () { add(this); });

    /* tabs */
    var tabs = qa('.bk-tablist [role=tab]', root);
    function selTab(t) { tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      var L = t.parentNode; L.scrollTo({ left: t.offsetLeft - L.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' }); }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { selTab(t); });
      t.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (k) { e.preventDefault(); var nx = tabs[(i + k + tabs.length) % tabs.length]; nx.focus(); selTab(nx); } }); });

    /* sticky bar */
    var st = q('[data-bk-sticky]'), cta = q('[data-bk-cta]'), tick = false;
    function stick() { tick = false; if (!st) return;
      var fin = document.querySelector('.bk-final');
      var past = cta.getBoundingClientRect().bottom < 0, atEnd = fin && fin.getBoundingClientRect().top < window.innerHeight;
      var show = past && !atEnd; st.classList.toggle('show', show); st.setAttribute('aria-hidden', String(!show)); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(stick); } }, { passive: true });
    stick();

    function toBuy() { var box = q('[data-bk-buy-box]'); var y = box.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
    mainApi = {
      pick: function (s) { setPack(1); state.units = [vFor(s).title]; renderUnits(); update(); showShade(s); toBuy(); },
      pack: function (n) { setPack(n); toBuy(); },
      toBuy: toBuy
    };
    setPack(1);
  }

  function initRel(el) {
    if (el.__bk || el.children.length) return; el.__bk = true;
    if (!el.dataset.pid) { el.closest('section').style.display = 'none'; return; }
    var link = (el.closest('section').querySelector('.bk-rc .go') || {}).textContent || 'Shop now →';
    fetch(rootUrl + 'recommendations/products.json?product_id=' + el.dataset.pid + '&limit=' + (el.dataset.limit || 4) + '&intent=related')
      .then(function (r) { return r.json(); }).then(function (j) { var ps = (j.products || []);
        if (!ps.length) { el.closest('section').style.display = 'none'; return; }
        el.innerHTML = ps.map(function (p) { var img = p.featured_image || '';
          if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          return '<a class="bk-rc" href="' + p.url + '"><span class="im">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="600" height="600">' : '') + '</span><b>' + String(p.title).replace(/</g, '&lt;') + '</b><span class="pr">' + inr(p.price) + '</span><span class="go">Shop now →</span></a>'; }).join(''); })
      .catch(function () { el.closest('section').style.display = 'none'; });
  }

  function initAll() { qa('[data-bk-main]').forEach(initMain); qa('[data-bk-rel]').forEach(initRel); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bk-pick],[data-bk-pack],[data-bk-buy]'); if (!t) return;
    if (!mainApi) { var m = document.querySelector('[data-bk-main]'); if (m) m.scrollIntoView({ behavior: 'smooth' }); return; }
    if (t.hasAttribute('data-bk-pick')) mainApi.pick(t.getAttribute('data-bk-pick'));
    else if (t.hasAttribute('data-bk-pack')) mainApi.pack(+t.getAttribute('data-bk-pack'));
    else mainApi.toBuy();
  });
  document.addEventListener('shopify:section:load', initAll);

  window.BKKohl = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();